var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AbstractEndpoint = require('../endpoint');

module.exports =
/*#__PURE__*/
function (_AbstractEndpoint) {
  "use strict";

  _inherits(GuildEndpoint, _AbstractEndpoint);

  function GuildEndpoint(client, id) {
    var _this;

    _classCallCheck(this, GuildEndpoint);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GuildEndpoint).call(this, client));
    _this.id = id;
    _this.url = '/v2/guild';
    _this.isAuthenticated = true;
    _this.isOptionallyAuthenticated = true;
    _this.cacheTime = 60 * 60;
    return _this;
  }

  _createClass(GuildEndpoint, [{
    key: "get",
    value: function get(id) {
      return _get(_getPrototypeOf(GuildEndpoint.prototype), "get", this).call(this, "/".concat(id), true);
    }
  }, {
    key: "permissions",
    value: function permissions() {
      return new PermissionsEndpoint(this);
    }
  }, {
    key: "search",
    value: function search(name) {
      return new SearchEndpoint(this, name);
    }
  }, {
    key: "upgrades",
    value: function upgrades() {
      if (this.id === undefined) {
        return new AllUpgradesEndpoint(this);
      }

      return new UpgradesEndpoint(this, this.id);
    }
  }, {
    key: "log",
    value: function log() {
      return new LogEndpoint(this, this.id);
    }
  }, {
    key: "members",
    value: function members() {
      return new MembersEndpoint(this, this.id);
    }
  }, {
    key: "ranks",
    value: function ranks() {
      return new RanksEndpoint(this, this.id);
    }
  }, {
    key: "stash",
    value: function stash() {
      return new StashEndpoint(this, this.id);
    }
  }, {
    key: "storage",
    value: function storage() {
      return new StorageEndpoint(this, this.id);
    }
  }, {
    key: "teams",
    value: function teams() {
      return new TeamsEndpoint(this, this.id);
    }
  }, {
    key: "treasury",
    value: function treasury() {
      return new TreasuryEndpoint(this, this.id);
    }
  }]);

  return GuildEndpoint;
}(AbstractEndpoint);

var PermissionsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint2) {
  "use strict";

  _inherits(PermissionsEndpoint, _AbstractEndpoint2);

  function PermissionsEndpoint(client) {
    var _this2;

    _classCallCheck(this, PermissionsEndpoint);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(PermissionsEndpoint).call(this, client));
    _this2.url = '/v2/guild/permissions';
    _this2.isPaginated = true;
    _this2.isBulk = true;
    _this2.isLocalized = true;
    _this2.cacheTime = 24 * 60 * 60;
    return _this2;
  }

  return PermissionsEndpoint;
}(AbstractEndpoint);

var SearchEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint3) {
  "use strict";

  _inherits(SearchEndpoint, _AbstractEndpoint3);

  function SearchEndpoint(client) {
    var _this3;

    _classCallCheck(this, SearchEndpoint);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(SearchEndpoint).call(this, client));
    _this3.url = '/v2/guild/search';
    _this3.cacheTime = 60 * 60;
    return _this3;
  }

  _createClass(SearchEndpoint, [{
    key: "name",
    value: function name(_name) {
      return _get(_getPrototypeOf(SearchEndpoint.prototype), "get", this).call(this, "?name=".concat(encodeURIComponent(_name)), true).then(function (result) {
        return result[0];
      });
    }
  }]);

  return SearchEndpoint;
}(AbstractEndpoint);

var AllUpgradesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint4) {
  "use strict";

  _inherits(AllUpgradesEndpoint, _AbstractEndpoint4);

  function AllUpgradesEndpoint(client) {
    var _this4;

    _classCallCheck(this, AllUpgradesEndpoint);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(AllUpgradesEndpoint).call(this, client));
    _this4.url = '/v2/guild/upgrades';
    _this4.isPaginated = true;
    _this4.isBulk = true;
    _this4.isLocalized = true;
    _this4.cacheTime = 24 * 60 * 60;
    return _this4;
  }

  return AllUpgradesEndpoint;
}(AbstractEndpoint);

var LogEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint5) {
  "use strict";

  _inherits(LogEndpoint, _AbstractEndpoint5);

  function LogEndpoint(client, id) {
    var _this5;

    _classCallCheck(this, LogEndpoint);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(LogEndpoint).call(this, client));
    _this5.url = "/v2/guild/".concat(encodeURIComponent(id), "/log");
    _this5.isAuthenticated = true;
    _this5.cacheTime = 5 * 60;
    return _this5;
  }

  _createClass(LogEndpoint, [{
    key: "since",
    value: function since(logId) {
      return _get(_getPrototypeOf(LogEndpoint.prototype), "get", this).call(this, "?since=".concat(logId), true);
    }
  }]);

  return LogEndpoint;
}(AbstractEndpoint);

var MembersEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint6) {
  "use strict";

  _inherits(MembersEndpoint, _AbstractEndpoint6);

  function MembersEndpoint(client, id) {
    var _this6;

    _classCallCheck(this, MembersEndpoint);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(MembersEndpoint).call(this, client));
    _this6.url = "/v2/guild/".concat(encodeURIComponent(id), "/members");
    _this6.isAuthenticated = true;
    _this6.cacheTime = 5 * 60;
    return _this6;
  }

  return MembersEndpoint;
}(AbstractEndpoint);

var RanksEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint7) {
  "use strict";

  _inherits(RanksEndpoint, _AbstractEndpoint7);

  function RanksEndpoint(client, id) {
    var _this7;

    _classCallCheck(this, RanksEndpoint);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(RanksEndpoint).call(this, client));
    _this7.url = "/v2/guild/".concat(encodeURIComponent(id), "/ranks");
    _this7.isAuthenticated = true;
    _this7.cacheTime = 5 * 60;
    return _this7;
  }

  return RanksEndpoint;
}(AbstractEndpoint);

var StashEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint8) {
  "use strict";

  _inherits(StashEndpoint, _AbstractEndpoint8);

  function StashEndpoint(client, id) {
    var _this8;

    _classCallCheck(this, StashEndpoint);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(StashEndpoint).call(this, client));
    _this8.url = "/v2/guild/".concat(encodeURIComponent(id), "/stash");
    _this8.isAuthenticated = true;
    _this8.cacheTime = 5 * 60;
    return _this8;
  }

  return StashEndpoint;
}(AbstractEndpoint);

var StorageEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint9) {
  "use strict";

  _inherits(StorageEndpoint, _AbstractEndpoint9);

  function StorageEndpoint(client, id) {
    var _this9;

    _classCallCheck(this, StorageEndpoint);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(StorageEndpoint).call(this, client));
    _this9.url = "/v2/guild/".concat(encodeURIComponent(id), "/storage");
    _this9.isAuthenticated = true;
    _this9.cacheTime = 5 * 60;
    return _this9;
  }

  return StorageEndpoint;
}(AbstractEndpoint);

var TeamsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint10) {
  "use strict";

  _inherits(TeamsEndpoint, _AbstractEndpoint10);

  function TeamsEndpoint(client, id) {
    var _this10;

    _classCallCheck(this, TeamsEndpoint);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(TeamsEndpoint).call(this, client));
    _this10.url = "/v2/guild/".concat(encodeURIComponent(id), "/teams");
    _this10.isAuthenticated = true;
    _this10.cacheTime = 5 * 60;
    return _this10;
  }

  return TeamsEndpoint;
}(AbstractEndpoint);

var TreasuryEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint11) {
  "use strict";

  _inherits(TreasuryEndpoint, _AbstractEndpoint11);

  function TreasuryEndpoint(client, id) {
    var _this11;

    _classCallCheck(this, TreasuryEndpoint);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(TreasuryEndpoint).call(this, client));
    _this11.url = "/v2/guild/".concat(encodeURIComponent(id), "/treasury");
    _this11.isAuthenticated = true;
    _this11.cacheTime = 5 * 60;
    return _this11;
  }

  return TreasuryEndpoint;
}(AbstractEndpoint);

var UpgradesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint12) {
  "use strict";

  _inherits(UpgradesEndpoint, _AbstractEndpoint12);

  function UpgradesEndpoint(client, id) {
    var _this12;

    _classCallCheck(this, UpgradesEndpoint);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(UpgradesEndpoint).call(this, client));
    _this12.url = "/v2/guild/".concat(encodeURIComponent(id), "/upgrades");
    _this12.isAuthenticated = true;
    _this12.cacheTime = 5 * 60;
    return _this12;
  }

  return UpgradesEndpoint;
}(AbstractEndpoint);